var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVendorOnboardStart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 324.47,
    height: 275.438,
    viewBox: "0 0 324.47 275.438",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3506",
    transform: "translate(-1295.401 -430.406)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12635",
    d: "M828.865 348.4c3.471 6.825 6.207 13.865 13.865 13.865a13.865 13.865 0 0 0 0-27.729c-7.782-.102-20.33 1.157-13.865 13.864z",
    transform: "translate(743.001 176.419)",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12636",
    d: "m566.224 504.1-5.925 1.32-7.913-22.226 8.745-1.949z",
    transform: "translate(1016.54 187.459)",
    style: {
      fill: "#a0616a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12637",
    d: "m838.612 702.365-19.106 4.258-.054-.242a7.619 7.619 0 0 1 5.779-9.094l11.669-2.6z",
    transform: "translate(746.943 -5.4)",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12638",
    d: "M606.746 519.57h-6.071l-2.888-23.416h8.96z",
    transform: "translate(993.62 179.932)",
    style: {
      fill: "#a0616a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12639",
    d: "M871.414 719.181h-19.575v-.248a7.619 7.619 0 0 1 7.619-7.619h11.956z",
    transform: "translate(730.5 -13.795)",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12640",
    d: "M847.414 612.782h-7.748a2.237 2.237 0 0 1-2.208-1.926l-7.023-54.328a.743.743 0 0 0-1.453-.091l-4.162 15.513 3.752 35.331a2.226 2.226 0 0 1-1.712 2.428l-6.146 1.418a2.239 2.239 0 0 1-2.626-1.5l-9.9-34.348a19.367 19.367 0 0 1-.806-7.8l3.1-30.965.235.012 41.343 1.992-2.417 72.113a2.22 2.22 0 0 1-2.229 2.151z",
    transform: "translate(752.992 74.45)",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 2917",
    cx: 12.162,
    cy: 12.162,
    r: 12.162,
    transform: "translate(1572.886 514.627)",
    style: {
      fill: "#a0616a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12641",
    d: "M851.537 471.753h-.121l-41.216-2.219a2.228 2.228 0 0 1-2-2.908l3.263-10.131a65.539 65.539 0 0 0 1.731-33.61 20.976 20.976 0 0 1 3.726-16.907 20.666 20.666 0 0 1 14.934-8.243q.3-.024.608-.043a20.882 20.882 0 0 1 21.884 23.942l-2.874 19.3 2.291 28.414a2.228 2.228 0 0 1-2.22 2.407z",
    transform: "translate(752.587 144.55)",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12642",
    d: "M785.406 528.609a4.979 4.979 0 0 0 .777-7.6l7.937-15.809-9.131 1.081-6.137 14.852a5.006 5.006 0 0 0 6.554 7.477z",
    transform: "translate(767.995 90.259)",
    style: {
      fill: "#a0616a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12643",
    d: "M898.663 532.665a4.979 4.979 0 0 1 .5-7.619l-5.182-16.919 8.822 2.592 3.569 15.669a5.006 5.006 0 0 1-7.711 6.276z",
    transform: "translate(709.224 88.781)",
    style: {
      fill: "#a0616a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12644",
    d: "M888.292 472.277a2.217 2.217 0 0 1-2.206-1.936l-4.124-31.108-6.579-24.309a7.025 7.025 0 0 1 6.609-8.858 7.053 7.053 0 0 1 7.1 5.841l9.8 57.412a2.229 2.229 0 0 1-2.1 2.6l-8.4.355z",
    transform: "translate(718.737 140.305)",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12645",
    d: "M791.657 467.085a2.279 2.279 0 0 1-.474-.05l-8.223-1.753a2.228 2.228 0 0 1-1.638-2.916L800.58 407.4a7.064 7.064 0 0 1 7.974-4.573 7.026 7.026 0 0 1 5.036 9.838l-10.56 22.9-9.253 29.951a2.216 2.216 0 0 1-2.12 1.569z",
    transform: "translate(766.162 142.003)",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12646",
    d: "M831.247 346a16.542 16.542 0 0 0 9.453 2.922 10.137 10.137 0 0 1-4.018 1.653 33.354 33.354 0 0 0 13.624.077 8.818 8.818 0 0 0 2.852-.98 3.61 3.61 0 0 0 1.76-2.354c.3-1.708-1.032-3.259-2.414-4.3a17.81 17.81 0 0 0-14.966-2.991 8.2 8.2 0 0 0-4.432 2.5 4.038 4.038 0 0 0-.373 4.795z",
    transform: "translate(740.896 173.915)",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12647",
    d: "M485.643 171.875H276.682a4.322 4.322 0 0 0-4.318 4.318v203.673a4.322 4.322 0 0 0 4.318 4.318H295v-1.233h-18.318a3.088 3.088 0 0 1-3.085-3.085V176.193a3.088 3.088 0 0 1 3.085-3.085h208.961a3.09 3.09 0 0 1 3.09 3.085v203.673a3.06 3.06 0 0 1-.51 1.693 3.192 3.192 0 0 1-1.169 1.05 3.063 3.063 0 0 1-1.411.342h-18.321v1.233h18.321a4.314 4.314 0 0 0 3.283-1.515.959.959 0 0 0 .094-.119 4.037 4.037 0 0 0 .619-1.045 4.208 4.208 0 0 0 .327-1.639V176.193a4.323 4.323 0 0 0-4.323-4.318z",
    transform: "translate(1023.037 258.531)",
    style: {
      fill: "#cbcbcb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1163",
    transform: "translate(1296.017 447.714)",
    style: {
      fill: "#cbcbcb"
    },
    d: "M0 0h216.367v1.234H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 2918",
    cx: 3.703,
    cy: 3.703,
    r: 3.703,
    transform: "translate(1302.805 435.963)",
    style: {
      fill: "#cbcbcb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 2919",
    cx: 3.703,
    cy: 3.703,
    r: 3.703,
    transform: "translate(1313.452 435.963)",
    style: {
      fill: "#cbcbcb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 2920",
    cx: 3.703,
    cy: 3.703,
    r: 3.703,
    transform: "translate(1324.098 435.963)",
    style: {
      fill: "#cbcbcb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12648",
    d: "M484.507 251.405H380.026a6.437 6.437 0 1 1 0-12.874h104.481a6.437 6.437 0 1 1 0 12.874zm-104.481-11.884a5.447 5.447 0 1 0 0 10.894h104.481a5.447 5.447 0 1 0 0-10.894z",
    transform: "translate(971.936 224.881)",
    style: {
      fill: "#cbcbcb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12649",
    d: "M481.97 377.468H324.507a8.427 8.427 0 0 1-8.418-8.418v-50.507a8.427 8.427 0 0 1 8.418-8.418H481.97a8.427 8.427 0 0 1 8.418 8.418v50.507a8.427 8.427 0 0 1-8.418 8.418zm-157.463-66.353a7.436 7.436 0 0 0-7.428 7.428v50.507a7.436 7.436 0 0 0 7.428 7.428H481.97a7.436 7.436 0 0 0 7.428-7.428v-50.507a7.436 7.436 0 0 0-7.428-7.428z",
    transform: "translate(1000.963 188.738)",
    style: {
      fill: "#cbcbcb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12650",
    d: "M473.714 364.548H418.75a3.961 3.961 0 1 1 0-7.923h54.964a3.961 3.961 0 1 1 0 7.923z",
    transform: "translate(951.137 165.264)",
    style: {
      fill: "#86c232"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12651",
    d: "M524.716 391.548H418.75a3.961 3.961 0 1 1 0-7.923h105.966a3.961 3.961 0 1 1 0 7.923z",
    transform: "translate(951.137 151.633)",
    style: {
      fill: "#86c232"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 2921",
    cx: 14.855,
    cy: 14.855,
    r: 14.855,
    transform: "translate(1328.589 517.68)",
    style: {
      fill: "#86c232"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12652",
    d: "M618.6 424.048h-13.861a3.961 3.961 0 1 1 0-7.923H618.6a3.961 3.961 0 0 1 0 7.923z",
    transform: "translate(857.244 135.226)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12653",
    d: "M618.6 424.048h-13.861a3.961 3.961 0 1 1 0-7.923H618.6a3.961 3.961 0 0 1 0 7.923z",
    transform: "translate(857.244 135.226)",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12654",
    d: "M481.965 494.125H324.5a8.43 8.43 0 0 0-8.418 8.418v50.507a8.43 8.43 0 0 0 8.418 8.418h157.465a8.427 8.427 0 0 0 8.418-8.418v-50.507a8.427 8.427 0 0 0-8.418-8.418zm7.428 58.925a7.434 7.434 0 0 1-7.428 7.428H324.5a7.437 7.437 0 0 1-7.428-7.428v-50.507a7.437 7.437 0 0 1 7.428-7.428h157.465a7.433 7.433 0 0 1 7.428 7.427z",
    transform: "translate(1000.966 95.849)",
    style: {
      fill: "#cbcbcb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12655",
    d: "M473.714 548.548H418.75a3.961 3.961 0 1 1 0-7.923h54.964a3.961 3.961 0 1 1 0 7.923z",
    transform: "translate(951.137 72.375)",
    style: {
      fill: "#86c232"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12656",
    d: "M524.716 575.548H418.75a3.961 3.961 0 0 1 0-7.923h105.966a3.961 3.961 0 0 1 0 7.923z",
    transform: "translate(951.137 58.744)",
    style: {
      fill: "#86c232"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 2922",
    cx: 14.855,
    cy: 14.855,
    r: 14.855,
    transform: "translate(1328.589 608.791)",
    style: {
      fill: "#86c232"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12657",
    d: "M618.6 608.048h-13.861a3.961 3.961 0 1 1 0-7.923H618.6a3.961 3.961 0 0 1 0 7.923z",
    transform: "translate(857.244 42.337)",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12658",
    d: "M855.455 727.115h-69.324a.5.5 0 1 1 0-.99h69.324a.5.5 0 1 1 0 .99z",
    transform: "translate(763.921 -21.271)",
    style: {
      fill: "#3f3d56"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendorOnboardStart);
export default __webpack_public_path__ + "static/media/VendorOnboardStart.76d55f6a5710815ede0c11bff2138d10.svg";
export { ForwardRef as ReactComponent };